<ng-container *ngIf="config.printMode; else notPrintMode">
  <app-line-chart
    *ngFor="let splittedData of getSplittedData()"
    [config]="config"
    [data]="splittedData"
    [interactivity]="false"
    [unit]="unit"
  >
  </app-line-chart>
</ng-container>
<ng-template #notPrintMode>
  <app-line-chart [config]="config" [data]="data" [unit]="unit">
  </app-line-chart>
</ng-template>

<div
  class="ranking"
  *ngIf="currentDelivery && config.categories && rankings.length !== 0"
>
  <ul *ngFor="let ranking of rankings; let index = index">
    <li class="head">
      <span class="left">{{ config.labels[index] | translate }}</span>
      <span class="right">{{ 'Total ' + unit | translate }}</span>
    </li>
    <li *ngFor="let val of ranking">
      <div class="color-box" [ngStyle]="{ backgroundColor: val.color }"></div>
      <img
        *ngIf="val.brand"
        src="/assets/img/brands/{{ val.brand }}/logo.svg"
        alt="{{ val.brand | translate }}"
      />
      <span class="left"> {{ val.rank }}. {{ val.name | translate }} </span>
      <span class="right">{{ val.value | number : '1.0-0' }}</span>
    </li>
  </ul>
</div>
